<template>
  <div class="field">
    <div class="field-label is-normal" v-if="config.label">
      <label class="label">{{config.label}}</label>
    </div>
    <div class="file has-name" v-if="config.type === 'file'">
      <label class="file-label">
        <input
          class="file-input"
          :type="config.type"
          :placeholder="config.placeholder"
          v-on:change="updateFile($event.target)"
        />
        <span class="file-cta">
          <span class="file-icon">
            <i class="material-icons">cloud_upload</i>
          </span>
          <!-- <span class="file-label">Choose a file…</span> -->
        </span>
        <span class="file-name" v-if="fileName !== ''">{{fileName}}</span>
        <span class="file-name has-text-grey" v-if="fileName === ''">{{config.placeholder}}</span>
      </label>
    </div>
    <div class="field-body" v-if="config.type !== 'file'">
      <div class="field">
        <div class="control" :class="{'has-icons-left': config.icon}">
          <input
            class="input"
            :type="config.type"
            :value="value"
            :placeholder="config.placeholder"
            :maxlength="config.maxLength ? config.maxLength : 100"
            v-on:input="updateValue($event.target.value)"
          />

          <span class="icon is-small is-left" v-if="config.icon">
            <i class="material-icons">{{config.icon}}</i>
          </span>
        </div>
        <span class="label-error" v-if="config.error">{{config.message}}</span>
      </div>
    </div>
  </div>
</template>
<style lang="scss" >
@import "./src/bulma/form/input-textarea";
@import "./src/bulma/form/file";
.field {
  max-width: 100%;
}

.file,
.file-label {
  width: 100%;
  .file-name {
    width: 100%;
    max-width: none;
  }
}
</style>
<script lang="ts">
// @ is an alias to /src
import { Component, Prop, Vue } from 'vue-property-decorator';

import { IInput } from './';

@Component({
  name: 'Input'
})
class Input extends Vue {
  @Prop({ required: true }) public config!: IInput;
  @Prop({ required: true }) public value!: string | number;
  public fileName = '';
  public created() {}
  public updateValue(value: string | number) {
    this.$emit('input', value);
    this.config.error = false;
    if (this.config.onInput) {
      this.config.onInput(value);
    }
  } public updateFile($input: HTMLInputElement) {
    if ($input.files) {
      this.fileName = $input.files[0].name;
      this.$emit('input', $input.files[0]);
    }
  }
}
export default Input;
</script>